import header from '@/views/common/header';
import gnb from '@/views/common/gnb';

export default [
  {
    path: '/views/detailview/abap/ci/:systemId',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/detailview/abap/centralInstance'),
      header,
      gnb,
    },
  },
  {
    path: '/views/detailview/abap/os/:systemId',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/detailview/abap/operatingSystem'),
      header,
      gnb,
    },
  },
  {
    path: '/views/detailview/abap/user/:systemId',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/detailview/abap/user'),
      header,
      gnb,
    },
  },
  {
    path: '/views/detailview/abap/process/:systemId',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/detailview/abap/process'),
      header,
      gnb,
    },
  },
  // BEGIN::Added.by.KWShin.2024.09.11.
  {
    path: '/views/detailview/abap/dbms/:systemId',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/detailview/abap/dbms'),
      header,
      gnb,
    },
  },
  // FINISH::Added.by.KWShin.2024.09.11.
  // BEGIN::Added.by.HJSeo.2026.08.10.
  // HANA DB 상세(Mockup). 수집기/API 연동 전 화면 시안이다.
  {
    path: '/views/detailview/abap/hanadb/:systemId',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/detailview/abap/hanadb'),
      header,
      gnb,
    },
  },
  // FINISH::Added.by.HJSeo.2026.08.10.
  // BEGIN::Modified.by.KWShin.2024.04.01.
  // {
  //   path: '/views/detailview/abap/dump/:systemId',
  //   components: {
  //     default: () => import('../views/detailview/abap/dump'),
  //     header,
  //     gnb,
  //   },
  // },
  // --------------------------------------------------------------------------
  {
    path: '/views/detailview/abap/dump/:systemId',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/detailview/abap/dumpLog'),
      header,
      gnb,
    },
  },
  // FINISH::Modified.by.KWShin.2024.04.01.
  // BEGIN::Modified.by.KWShin.2025.10.02.
  {
    path: '/views/detailview/abap/batch/:systemId',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/detailview/abap/batch-job'),
      header,
      gnb,
    },
  },
  // FINISH::Modified.by.KWShin.2025.10.02.
  {
    path: '/views/detailview/abap/data-viewer',
    meta: { fixedMinSize: false },
    components: {
      default: () => import('../views/detailview/components/abap/GridViewer.vue'),
    },
  },
  {
    path: '/views/detailview/java/jm/:systemId',
    meta: { stackType: 'JAVA' },
    components: {
      default: () => import('../views/detailview/java/jvmMemory'),
      header,
      gnb,
    },
  },
  {
    path: '/views/detailview/java/log/:systemId',
    meta: { stackType: 'JAVA' },
    components: {
      default: () => import('../views/detailview/java/javaLog'),
      header,
      gnb,
    },
  },
  {
    path: '/views/detailview/java/ci/:systemId',
    meta: { stackType: 'JAVA' },
    components: {
      default: () => import('../views/detailview/java/centralInstance'),
      header,
      gnb,
    },
  },
  {
    path: '/views/detailview/java/os/:systemId',
    meta: { stackType: 'JAVA' },
    components: {
      default: () => import('../views/detailview/java/operatingSystem'),
      header,
      gnb,
    },
  },
  {
    path: '/views/detailview/java/db/:systemId',
    meta: { stackType: 'JAVA' },
    components: {
      default: () => import('../views/detailview/java/database'),
      header,
      gnb,
    },
  },
  {
    path: '/views/detailview/java/ut/:systemId',
    meta: { stackType: 'JAVA' },
    components: {
      default: () => import('../views/detailview/java/userThread'),
      header,
      gnb,
    },
  },
  {
    path: '/views/detailview/java/msc/:systemId',
    meta: { stackType: 'JAVA' },
    components: {
      default: () => import('../views/detailview/java/miscellaneous'),
      header,
      gnb,
    },
  },
  {
    path: '/views/detailview/java/data-viewer',
    meta: { fixedMinSize: false },
    components: {
      default: () => import('../views/detailview/components/java/GridViewer.vue'),
    },
  },
];
